var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "new-employee" }, [
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            { attrs: { label: "Nombre", "label-for": "privateName" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateName",
                  placeholder: "Rafaeli Camposorio Ruízo",
                  icon: "account",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("name", $event)
                  }
                },
                model: {
                  value: _vm.privateName,
                  callback: function($$v) {
                    _vm.privateName = $$v
                  },
                  expression: "privateName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            { attrs: { label: "Email", "label-for": "privateEmail" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateEmail",
                  placeholder: "correo@mail.com",
                  icon: "email",
                  type: "email",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("email", $event)
                  }
                },
                model: {
                  value: _vm.privateEmail,
                  callback: function($$v) {
                    _vm.privateEmail = $$v
                  },
                  expression: "privateEmail"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            { attrs: { label: "CURP", "label-for": "privateCurp" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateCurp",
                  placeholder: "CABL840215MDFSRS01",
                  icon: "human-male",
                  pattern: _vm.curpPattern,
                  disabled: _vm.loading,
                  loading: _vm.loading
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("curp", $event)
                  }
                },
                model: {
                  value: _vm.privateCurp,
                  callback: function($$v) {
                    _vm.privateCurp = $$v
                  },
                  expression: "privateCurp"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }